<template>
  <div class="competition-standings">
    <NotificationBanner
      v-if="isNil(slip) || isNil(slip.teams) || slip.teams.length === 0"
      :message="$t('competition-standings.empty-results')"
    />

    <div v-else class="competition-standings-body">
      <div></div>
      <div>
        <small>{{ $t('competition-standings.heading-team') }}</small>
      </div>
      <div>
        <small>{{ $t('competition-standings.heading-bowlers') }}</small>
      </div>
      <div>
        <small>{{ $t('competition-standings.heading-team-score') }}</small>
      </div>
      <div>
        <small>{{ $t('competition-standings.heading-score') }}</small>
      </div>
      <div>
        <small>{{ $t('competition-standings.heading-handicap') }}</small>
      </div>
      <div>
        <small>{{ $t('competition-standings.heading-average') }}</small>
      </div>

      <template v-for="(team, index) in slip.teams" :key="index">
        <div>
          <small>{{ 1 + index }}</small>
        </div>
        <div>
          <small>{{ formatValue(team.name) }}</small>
        </div>
        <div>
          <small>&nbsp;</small>
          <small
            v-for="(member, j) in team.members"
            :key="`member-${index}-${j}`"
          >
            {{ member.fullName }}
          </small>
        </div>
        <div>
          <small>{{ formatFloat(team.score, 0) }}</small>
        </div>
        <div>
          <small>&nbsp;</small>
          <small
            v-for="(member, j) in team.members"
            :key="`score-${index}-${j}`"
          >
            {{ formatFloat(member.score, 0) }}
          </small>
        </div>
        <div>
          <small>&nbsp;</small>
          <small
            v-for="(member, j) in team.members"
            :key="`handicap-${index}-${j}`"
          >
            {{ formatFloat(member.handicap, 0) }}
          </small>
        </div>
        <div>
          <small>{{ formatFloat(team.average, 2) }}</small>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import isNil from 'lodash/isNil'
import { PropType } from 'vue'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import { CompetitionTeamStandingsSlip } from '@/store/public/competition.types'
import { formatFloat, formatValue } from '@/utils/format'

defineProps({
  slip: {
    type: Object as PropType<CompetitionTeamStandingsSlip | null>,
    default: null,
  },
})
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.competition-standings {
  overflow-x: auto;

  .competition-standings-body {
    display: grid;
    grid-template-columns: repeat(7, auto);

    div {
      display: flex;
      flex-flow: column nowrap;
      gap: 0.25em;
      padding: 0.25em 0.75em;
      text-align: center;
      white-space: nowrap;
      border-bottom: $border-width solid $color-accent;
    }

    div:nth-child(-n + 7) {
      background-color: $color-accent;
      color: $color-text-inverted;
      font-weight: bold;
    }

    div:nth-child(7n + 1) {
      text-align: right;
    }

    div:nth-child(7n + 2),
    div:nth-child(7n + 3) {
      text-align: left;
    }
  }
}
</style>
